type ToResult<T> = {
  error: { message: string } & any;
  data: T | undefined;
};

export function tryCatch<T>(fn: () => T, errorCallback?: (error: Error) => void): ToResult<T> {
  try {
    const data = fn();
    return { error: undefined, data };
  } catch (error) {
    errorCallback?.(error);
    return { error, data: undefined };
  }
}

export async function tryCatchAsync(
  promise: Promise<any>,
  errorCallback?: (error: Error) => void,
): Promise<ToResult<any>> {
  try {
    const result = await promise;
    return { error: undefined, data: result };
  } catch (e) {
    errorCallback?.(e);
    return { error: e, data: undefined };
  }
}
